export const SET_DATE_FORMAT = 'SET_DATE_FORMAT';

export const setDateFormat = value => ({
  type: SET_DATE_FORMAT,
  payload: value,
});
